import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteProduct } from "api/product.api";
import { invalidateProductSide } from "lib/cacheInvalidation";

export const useDeleteProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteProduct,
    onSuccess: () => {
      invalidateProductSide(queryClient);
    },
  });
};
